import React from "react";
import { useState, useEffect } from "react";
import TomorrowIsHere from "../assets/Home/TomorrowIsHere.png";
import styles from "./style.module.css";

const NewsModal = ({ modalShowing, toggleModal }) => {
	const [modalVisible, setModalVisible] = useState(false);

	// checking if the user has visited the page and has seen the news modal //
	useEffect(() => {
		if (!localStorage.getItem("modalShown")) {
			console.log("Displaying modal");
			displayModal();
		}
	}, []);

	const displayModal = () => {
		setModalVisible(true);
		localStorage.setItem("modalShown", "true");
	};

	const downloadImage = () => {
		const link = document.createElement("a");
		link.href = TomorrowIsHere;
		link.download = "AnualReportNotification";
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	return (
		<div
			className={`${styles.modalOverlay} ${
				modalVisible ? styles.visible : " "
			}`}
			onClick={() => toggleModal(!modalShowing)}
		>
			<div className={styles.modalContent}>
				<h2 className={styles.clickMe}>Click Me </h2>
				<img
					src={TomorrowIsHere}
					alt="AnualReportNotification"
					className={styles.AnualReportNotificationImage}
					onClick={downloadImage}
				/>
			</div>
		</div>
	);
};

export default NewsModal;
